import s from "../../styles/Settings.styles";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { useCallback, useState } from "react";
import { Input, Tooltip } from "antd";
import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";

import { useFormik } from "formik";
import Text from "antd/lib/typography/Text";
import useRootUserMutations from "graphql/useRootUserMutations";
import Loading from "components/common/loading";
import { useMessaging } from "context/MessagingContext";
import { useTranslation } from "react-i18next";
import { useBusinessContext } from "../../BusinessApp";

function HolderData() {
  const { t } = useTranslation();

  const { rootUser, loading } = useBusinessContext();

  const { updateRootUser } = useRootUserMutations();

  const { setInfoMessage, setErrorMessage } = useMessaging();

  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  const {
    values,
    getFieldProps,
    handleSubmit,
    handleChange,
    isValid,
    dirty,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: rootUser?.name || "",
      lastName: rootUser?.lastName || "",
      phone: rootUser?.phone || "",
      email: rootUser?.email || "",
      idNumber: rootUser?.idNumber || "",
    },
    onSubmit: async (values) => {
      try {
        setEditing(true);
        setSaving(true);
        await updateRootUser(rootUser, values);
        setSaving(false);
        setEditing(false);
        onUpdateSuccess();
      } catch (error) {
        setEditing(false);
        setErrorMessage({ error });
      }
    },
  });

  const onUpdateSuccess = useCallback(() => {
    setInfoMessage({
      titleAlert: t("containers.SettingsHolderData.infoEdit"),
      info1: t("containers.SettingsHolderData.infoEditDB"),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <Loading />;

  return (
    <s.TopSectionsContainer>
      <s.LeftContainer>
        <s.SectionTitle style={{ marginBottom: "18px" }}>
          {t("containers.SettingsHolderData.holderData")}
        </s.SectionTitle>
        <s.Line style={{ marginBottom: "10px" }} />

        <s.gridInputContainer>
          <s.InputContainer>
            <s.SubTitle>{t("containers.SettingsHolderData.name")}</s.SubTitle>
            <Input
              placeholder={t("general.textPlaceholder")}
              disabled={!editing}
              value={values?.name}
              style={{ marginBottom: "27px" }}
              {...getFieldProps("name")}
            />
          </s.InputContainer>

          <s.InputContainer>
            <s.SubTitle>
              {t("containers.SettingsHolderData.surnames")}
            </s.SubTitle>
            <Input
              placeholder={t("general.textPlaceholder")}
              value={values?.lastName}
              disabled={!editing}
              {...getFieldProps("lastName")}
            />
          </s.InputContainer>
          <s.InputContainer>
            <s.SubTitle>{t("containers.SettingsHolderData.DNI")}</s.SubTitle>
            <Input
              placeholder={t("general.textPlaceholder")}
              disabled={!editing}
              value={values?.idNumber}
              {...getFieldProps("idNumber")}
            />
          </s.InputContainer>
          <s.InputContainer>
            <s.SubTitle>
              {t("containers.SettingsHolderData.telephone")}
            </s.SubTitle>
            <PhoneInput
              placeholder={t("general.textPlaceholder")}
              className="phone-input"
              disabled={!editing}
              international
              defaultCountry="ES"
              value={values?.phone}
              onChange={(value) =>
                handleChange({ target: { name: "phone", value } })
              }
            />
          </s.InputContainer>
        </s.gridInputContainer>

        <s.InputContainer style={{ marginTop: "27px" }}>
          <s.SubTitle>
            {`${t("containers.SettingsHolderData.email")} `}
            <Tooltip
              placement="right"
              color="white"
              title={
                <div style={{ color: "#000" }}>
                  <Text>
                    {t("containers.SettingsHolderData.InfoMessage")}{" "}
                    <Text strong>
                      {t("containers.SettingsHolderData.InfoMessageEmail")}
                    </Text>{" "}
                    {t("containers.SettingsHolderData.InfoMessage2")}
                    <Text strong>
                      {" "}
                      {t("containers.SettingsHolderData.InfoMessageEmail")}
                    </Text>
                  </Text>
                </div>
              }
            >
              <InfoCircleOutlined />
            </Tooltip>
          </s.SubTitle>

          <Input disabled value={values?.email} {...getFieldProps("email")} />
        </s.InputContainer>

        {!values?.idNumber && (
          <s.textUnvalid>
            {t("containers.SettingsHolderData.unvalidatedEmail")}
            <s.spantextUnvalid>
              {t("containers.SettingsHolderData.validateNow")}
            </s.spantextUnvalid>{" "}
          </s.textUnvalid>
        )}

        {!editing ? (
          <s.InputContainer style={{ marginTop: "47px" }}>
            <s.button onClick={() => setEditing(true)}>
              {t("containers.SettingsHolderData.edit")}
            </s.button>
          </s.InputContainer>
        ) : (
          <s.containerButton
            style={{
              marginTop: "47px",
            }}
          >
            <s.InputContainer style={{ marginRight: "15px" }}>
              <s.button onClick={() => [setEditing(false), resetForm()]}>
                {t("containers.SettingsHolderData.return")}
              </s.button>
            </s.InputContainer>
            <s.InputContainer>
              <s.buttonsave
                disabled={dirty && isValid}
                onClick={() => handleSubmit()}
              >
                {t("containers.SettingsHolderData.save")}
                {saving && (
                  <LoadingOutlined
                    style={{
                      fontSize: 24,
                      marginLeft: "15px",
                    }}
                    spin
                  />
                )}
              </s.buttonsave>
            </s.InputContainer>
          </s.containerButton>
        )}
      </s.LeftContainer>
    </s.TopSectionsContainer>
  );
}

export default HolderData;
